@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/colors';

.coverImage {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  width: 100%;
  height: 100%;

  .loading {
    visibility: hidden;
  }
}

.image {
  width: 100%;
  height: 100%;
}

.imageShimmer {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  inset: 0;
  z-index: 1;
}
